import { combineReducers } from 'redux';

export function createReducerManager(initialReducers) {

    const reducers = { ...initialReducers }
  
    let combinedReducer = combineReducers(reducers)
  
    let keysToRemove = []
  
    return {
      getReducerMap: () => reducers,
  
      reduce: (state, action) => {

        if (keysToRemove.length > 0) {
          state = { ...state }
          for (let key of keysToRemove) {
            delete state[key]
          }
          keysToRemove = []
        }
  
        return combinedReducer(state, action)
      },
  
      // Adds a new reducer with the specified key
      add: (key, reducer) => {
        if (!key || reducers[key]) {
          return
        }
  
        // Add the reducer to the reducer mapping
        reducers[key] = reducer
  
        // Generate a new combined reducer
        combinedReducer = combineReducers(reducers)
      },
  
      // Removes a reducer with the specified key
      remove: key => {
        if (!key || !reducers[key]) {
          return
        }
  
        // Remove it from the reducer mapping
        delete reducers[key]
  
        // Add the key to the list of keys to clean up
        keysToRemove.push(key)
  
        // Generate a new combined reducer
        combinedReducer = combineReducers(reducers)
      }
    }
}
